<div class="kr-header" data-testid="header_container">
  <h1
    class="kr-header__header"
    [translate]="header()"
    data-testid="header_title"></h1>

  <div class="kr-header__actions" data-testid="header_actions">
    @if (companies()?.length >= 1) {
      <kr-company-selector
        [selectedCompany]="selectedCompany"
        [companies]="companies()"
        (changeEvent)="changeCompany($event)"
        data-testid="header_company_selector" />
    }

    @if (account()) {
      <kr-user-card
        class="kr-header__user"
        [user]="account()"
        data-testid="header_user_card" />

      @for (balance of totalBalances(); track balance.provider.id) {
        <kr-total-balance
          [providerType]="balance.provider.type"
          [balance]="balance.balance"
          [currencies]="currencies()"
          data-testid="header_provider"
          (currencyChange)="changeCurrency($event, balance.provider)">
        </kr-total-balance>
      }
    }
  </div>
</div>
